module.exports = __webpack_public_path__ + "img/icon-line.6832a799.png";